<div class="hero-image">
    <div class="horizontal-flip">
        <div class="hero-text">
            <h1 style="font-size: 60px; color: white;"></h1>
        </div>
    </div>
</div>

